import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import img1 from '../assets/images/box-item/card-item-9.jpg'
import img2 from '../assets/images/box-item/image-box-21.jpg'
import img3 from '../assets/images/box-item/image-box-6.jpg'
import img4 from '../assets/images/box-item/card-item-7.jpg'
import img5 from '../assets/images/box-item/card-item-9.jpg'
import img6 from '../assets/images/box-item/image-box-11.jpg'
import img7 from '../assets/images/box-item/card-item-4.jpg'
import img8 from '../assets/images/box-item/card-item-3.3.jpg'
const Activity02 = () => {
    const [dataBox] = useState([
        {
            title: 'Order',
            content:
                'Lorem ipsum dolor sit amet,consectetur adipisicing elit. Quis non, fugit totam vel laboriosam vitae.',
            time: '19th June, 2021',
        },
        {
            title: 'Sell',
            content:
                'Lorem ipsum dolor sit amet,consectetur adipisicing elit. Quis non, fugit totam vel laboriosam vitae.',
            time: '10 minutes ago',
        },
        {
            title: 'Sell',
            content:
                'Lorem ipsum dolor sit amet,consectetur adipisicing elit. Quis non, fugit totam vel laboriosam vitae.',
            time: '19th June, 2021',
        },
        {
            title: 'Order',
            content:
                'Lorem ipsum dolor sit amet,consectetur adipisicing elit. Quis non, fugit totam vel laboriosam vitae.',
            time: '10 minutes ago',
        },
        {
            title: 'Order',
            content:
                'Lorem ipsum dolor sit amet,consectetur adipisicing elit. Quis non, fugit totam vel laboriosam vitae.',
            time: '19th June, 2021',
        },
        {
            title: 'Sell',
            content:
                'Lorem ipsum dolor sit amet,consectetur adipisicing elit. Quis non, fugit totam vel laboriosam vitae.',
            time: '10 minutes ago',
        },
        {
            title: 'Sell',
            content:
                'Lorem ipsum dolor sit amet,consectetur adipisicing elit. Quis non, fugit totam vel laboriosam vitae.',
            time: '19th June, 2021',
        },
        {
            title: 'Order',
            content:
                'Lorem ipsum dolor sit amet,consectetur adipisicing elit. Quis non, fugit totam vel laboriosam vitae.',
            time: '10 minutes ago',
        },
        {
            title: 'Order',
            content:
                'Lorem ipsum dolor sit amet,consectetur adipisicing elit. Quis non, fugit totam vel laboriosam vitae.',
            time: '19th June, 2021',
        },
        {
            title: 'Sell',
            content:
                'Lorem ipsum dolor sit amet,consectetur adipisicing elit. Quis non, fugit totam vel laboriosam vitae.',
            time: '10 minutes ago',
        },
        {
            title: 'Sell',
            content:
                'Lorem ipsum dolor sit amet,consectetur adipisicing elit. Quis non, fugit totam vel laboriosam vitae.',
            time: '19th June, 2021',
        },
        {
            title: 'Order',
            content:
                'Lorem ipsum dolor sit amet,consectetur adipisicing elit. Quis non, fugit totam vel laboriosam vitae.',
            time: '10 minutes ago',
        },
    ])
    const [dataFilter] = useState([
        {
            name: 'Order',
            checked: 'checked',
        },
        {
            name: 'Sell',
            checked: 'checked',
        },
    ])

    const [visible, setVisible] = useState(8)
    const showMoreItems = () => {
        setVisible((prevValue) => prevValue + 4)
    }
    return (
        <div>
            <Header />

            <section className="tf-activity tf-section">
                <div className="themesflat-container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-9 col-md-8 col-12">
                            <div className="box-activity">
                                {dataBox.slice(0, visible).map((item, index) => (
                                    <div key={index} className="sc-card-activity style-2">
                                        <div className="content">
                                            <div className="infor">
                                                <h4>
                                                    <Link to="/item-details-01">{item.title}</Link>
                                                </h4>
                                                <div className="status">
                                                    <span className="author">{item.content}</span>
                                                </div>
                                                <div className="time">{item.time}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {visible < dataBox.length && (
                                <div className="btn-activity mg-t-10 center">
                                    <Link
                                        to="#"
                                        id="load-more"
                                        className="sc-button loadmore fl-button pri-3"
                                        onClick={showMoreItems}
                                    >
                                        <span>Load More</span>
                                    </Link>
                                </div>
                            )}
                        </div>
                        <div className="col-xl-4 col-lg-3 col-md-4 col-12">
                            <div id="side-bar" className="side-bar style-2">
                                <div class="create-order">
                                    <h3> Create Order/Sell </h3>
                                    <div class="card-bottom">
                                        <a class="sc-button fl-button pri-3 no-bg" href="/contact-02">
                                            <span>Create</span>
                                        </a>
                                    </div>
                                </div>

                                <div class="divider"></div>

                                <div className="widget widget-filter style-1 mgbt-0">
                                    <div className="header-widget-filter">
                                        <h3 className="title-widget">Filter</h3>
                                    </div>
                                    <form action="#" className="form-inner">
                                        {dataFilter.map((item, index) => (
                                            <div key={index}>
                                                <label>
                                                    {item.name}
                                                    <input type="checkbox" defaultChecked={item.checked} />
                                                    <span className="btn-checkbox"></span>
                                                </label>
                                                <br />
                                            </div>
                                        ))}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Activity02
